import { gsap } from 'gsap';
import { disableScroll, enableScroll } from '../helpers';

class Modal {
    constructor() {
        this.triggers = document.querySelectorAll('[data-modal-open]');

        this.triggers.forEach(trigger => this.init.bind(this)(trigger));
    }

    init(trigger) {
        const target = trigger.dataset.modalOpen;
        const modal = document.querySelector(`[data-modal="${target}"]`);
        if (!modal) return;

        const popup = modal.querySelector('.modal__popup');
        if (!popup) return;

        const close = modal.querySelector('.modal__close');
        const overlay = modal.querySelector('.modal__overlay');
        const content = modal.querySelector('.modal__content');

        const tl = gsap.timeline({
            paused: true,
        });

        tl.to(modal, {
            duration: 0.4,
            opacity: 1,
            visibility: 'visible',
            ease: 'power1.easeOut',
            onComplete: () => {
                const input = modal.querySelector('input');
                if (input) input.focus();
            },
        });

        tl.to(
            popup,
            {
                duration: 0.4,
                opacity: 1,
                y: '-50%',
                ease: 'power1.easeOut',
            },
            '-=0.2'
        );

        trigger.addEventListener('click', () => this.showModal(modal, tl));

        close &&
            close.addEventListener('click', () => this.hideModal(modal, tl));

        overlay &&
            overlay.addEventListener('click', () => this.hideModal(modal, tl));

        // Scrolling events
        content &&
            content.addEventListener('wheel', e => {
                e.preventDefault();
                content.scrollTop += e.deltaY;
            });

        // Key event
        document.addEventListener('keydown', e => {
            if (e.keyCode == 27 && modal.classList.contains('active')) {
                this.hideModal(modal, tl);
            }
        });
    }

    // Methods
    showModal(modal, tl) {
        if (modal.classList.contains('active')) return;
        modal.classList.add('active');

        tl.timeScale(1);
        tl.play();

        // Disable global scroll
        disableScroll();
    }

    hideModal(modal, tl) {
        if (!modal.classList.contains('active')) return;
        modal.classList.remove('active');

        tl.timeScale(1.5);
        tl.reverse();

        // Reset global scroll
        enableScroll();
    }
}

export default new Modal();
